import React from "react";

// Official WhatsApp glyph (single-path, inherits currentColor)
const WhatsAppIcon = ({ size = 24, className = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    width={size}
    height={size}
    fill="currentColor"
    className={className}
    aria-hidden="true"
    {...props}
  >
    <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.888 2.722.888.817 0 2.15-.515 2.478-1.318.187-.46.187-.86.13-.946-.086-.13-.33-.22-.716-.402z" />
    <path d="M16.002 2.667C8.634 2.667 2.668 8.633 2.668 16c0 2.507.692 4.93 2.006 7.044L2.668 29.333l6.445-1.984A13.247 13.247 0 0 0 16.002 29.333C23.369 29.333 29.335 23.367 29.335 16S23.369 2.667 16.002 2.667zm0 24.4a11.03 11.03 0 0 1-5.826-1.66l-.417-.248-3.82 1.175 1.202-3.72-.273-.43A11.03 11.03 0 0 1 4.935 16c0-6.11 4.955-11.067 11.067-11.067S27.069 9.89 27.069 16s-4.955 11.067-11.067 11.067z" />
  </svg>
);

export default WhatsAppIcon;
